module.exports = __webpack_public_path__ + "img/25800.997fb5f2.jpg";